import { render, staticRenderFns } from "./FileContractIcon.vue?vue&type=template&id=dc793dda"
import script from "./FileContractIcon.vue?vue&type=script&lang=js"
export * from "./FileContractIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports